import { render, staticRenderFns } from "./CellAttendees.vue?vue&type=template&id=a83e86a0&"
import script from "./CellAttendees.vue?vue&type=script&lang=js&"
export * from "./CellAttendees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports